import app from 'flarum/forum/app';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
export const t = (key, params = {}) => app.translator.trans(`ernestdefoe-concourse.forum.${key}`, params);

/** The same text, as a plain string, for attributes like aria-label. */
export const ts = (key, params = {}) => app.translator.trans(`ernestdefoe-concourse.forum.${key}`, params, true);
export function extensionEnabled(id) {
  return id in (flarum.extensions || {});
}
export function tagsEnabled() {
  return extensionEnabled('flarum-tags');
}
export function currentTag() {
  return tagsEnabled() && typeof app.currentTag === 'function' ? app.currentTag() : null;
}
export function canStart() {
  return !app.session.user || !!app.forum.attribute('canStartDiscussion');
}

/**
 * Open the composer the way core's sidebar button does — through
 * IndexSidebar's own action, so flarum/tags (and anything else extending it)
 * still pre-fills the current tag, and a guest is asked to log in first.
 */
export function startDiscussion() {
  IndexSidebar.prototype.newDiscussionAction.call(Object.create(IndexSidebar.prototype)).catch(() => {});
}